import './styles/tailwind.css'
import '@fancyapps/fancybox/dist/jquery.fancybox.min.css'
import '@fortawesome/fontawesome-free/css/all.min.css'

import './styles/main.scss'

import './scripts/core/debug.js';
import './scripts/core/datetime.js';
import './scripts/core/dynamic.js';
import './scripts/ui/ajaxmodal.js';
import './scripts/ui/modal.js';
import './scripts/ui/sidebar.js';
import './scripts/ui/tooltip.js';
import './scripts/ui/toast.js';
import './scripts/ui/system_alerts.js';
import './scripts/ui/unsaved-changes.js';
window.Taskello = window.Taskello || {};
window.Taskello.getTiptapCore = (() => {
    let promise = null;
    return () => {
        if (!promise) {
            promise = import('./scripts/editor/tiptap-core.js');
        }
        return promise;
    };
})();
if (document.querySelector('[data-component="textarea-editor"]')) {
    window.Taskello.getTiptapCore();
}
window.Taskello.getChart = (() => {
    let promise = null;
    return () => {
        if (!promise) {
            promise = import('./scripts/vendor/chart.js');
        }
        return promise;
    };
})();
if (document.querySelector('canvas')) {
    window.Taskello.getChart();
}
window.Taskello.getTable = (() => {
    let promise = null;
    return () => {
        if (!promise) {
            promise = import('./scripts/vendor/table.js');
        }
        return promise;
    };
})();
import './scripts/content/fancybox.js';
import './scripts/content/syntax-highlighting.js';
import './scripts/content/uml-diagrams.js';
if (document.querySelector('[data-component="conversations"]')) {
    import('./scripts/features/conversations.js');
}
import './scripts/ui/form.js'
import './scripts/core/theme.js'
if (document.evaluate('//*[@*[starts-with(name(),"data-dyn")]]', document, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null).singleNodeValue) {
    import('./scripts/vendor/dynamicjs.es.js');
}
import './scripts/features/websockets.js'

window.Taskello?.debugLog?.('Frontend bootstrap');
